module.exports = __webpack_public_path__ + "img/14.543ecce2.png";